import { useMemo, useState } from "react";
import classes from "./TopicToFocus.module.css";
import Search from "./Search";
import Pagination from "./Pagination";
import data from "./data.json";
import { Table } from "react-bootstrap";
import { isEmpty } from "../../utils/custom_funtions";

const TopicToFocus = () => {
    const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showEntries, setShowEntries] = useState(10);
  const ITEMS_PER_PAGE = +showEntries;
  const commentsData = useMemo(() => {
    let computedComments = data;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.topic.toLowerCase().includes(search.toLowerCase()) ||
        comment.subTopic.toLowerCase().includes(search.toLowerCase()) 
      );
    }

    setTotalItems(computedComments.length);
    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [data, currentPage, search, ITEMS_PER_PAGE]);

  return (
    <>
      <div className={classes.head}>
        <p className={classes.heading}>Topics To Focus-on</p>
        <Search
          onSearch={(value) => {
            setSearch(value);
            setCurrentPage(1);
          }}
        />
      </div>
      <div className={classes.line}></div>
      <div className={classes.section}>
      <div className="mb-2">
          Show{" "}
          <select
            value={showEntries}
            onChange={(e) => {
              setShowEntries(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
          </select>{" "}
          enteries
        </div>
        <Table responsive bordered className={classes.table}>
          <thead className={classes.header}>
            <tr>
            <th>Topic Name</th>
            <th>Sub-topic Name</th>
            <th>Correct Attempt %</th>
            </tr>
          </thead>
          <tbody>
            {isEmpty(commentsData) && !isEmpty(search) && (
              <tr>
                <td colSpan={3}>No data found !!</td>
              </tr>
            )}
            {commentsData.map((data, index) => (
              <tr>
                <td>{data.topic}</td>
                <td>{data.subTopic}</td>
                <td>{data.correct}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <p className="small ">
        Showing{" "}
        <b>
          {+showEntries < data.length
            ? +showEntries
            : data.length}
        </b>{" "}
        out of {data.length} enteries
      </p>
        <div className="mt-2">
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
    </>
  );
}

export default TopicToFocus